import {observer} from 'mobx-react';
import React, {useEffect} from 'react';

import {CouponStore, MODES, ShoppingClient} from '@udemy/shopping';

import {RedeemCoupon, StackableCouponProps} from './redeem-coupon.react-component';

interface RedeemCouponWithCartCouponStoreProps {
    couponStore: CouponStore;
    isInCheckoutPane?: boolean;
}

export const RedeemCouponWithCartCouponStore: React.FC<RedeemCouponWithCartCouponStoreProps> =
    observer(({couponStore, isInCheckoutPane = false}) => {
        useEffect(() => {
            ShoppingClient.validateDiscounts();
            couponStore.initialize();

            if (ShoppingClient.availableCoupons.length == 0) {
                couponStore.currentMode = MODES.OFF;
            }
        }, [couponStore]);

        const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            couponStore?.setCode(event.target.value);
        };

        const onSubmit = () => {
            couponStore?.applyInputCode();
        };

        const onApplyStackableCoupon = (coupons: StackableCouponProps[]) => {
            if (coupons.length > 0) {
                couponStore?.setCode(coupons[0].code);
                couponStore?.applyInputCode();
            }
        };

        const shouldShowApplyCouponButton = couponStore.currentMode === MODES.OFF;
        return (
            <RedeemCoupon
                couponStore={couponStore}
                removeCouponCodeClick={(code) => couponStore.removeCouponCode(code)}
                inputOnChange={onChange}
                inputOnSubmit={onSubmit}
                inputIsDisabled={!couponStore.allowSubmit}
                currentMode={couponStore.currentMode}
                currentCodes={couponStore.currentCodes}
                showStackableCoupons={true}
                showCartOptIn={true}
                showTitle={!shouldShowApplyCouponButton}
                stackableCoupons={ShoppingClient.availableCoupons}
                onApplyStackableCoupon={onApplyStackableCoupon}
                submittedCode={couponStore.submittedCode}
                inputCode={couponStore.inputCode}
                error={couponStore.error}
                isInCheckoutPane={isInCheckoutPane}
                showCouponInputModeButton={shouldShowApplyCouponButton}
                enterInputModeClick={() => couponStore.enterInputMode()}
            />
        );
    });
